import { render, staticRenderFns } from "./JoinOrgV2.vue?vue&type=template&id=37c0cb15&scoped=true"
import script from "./JoinOrgV2.vue?vue&type=script&lang=js"
export * from "./JoinOrgV2.vue?vue&type=script&lang=js"
import style0 from "./JoinOrgV2.vue?vue&type=style&index=0&id=37c0cb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0cb15",
  null
  
)

export default component.exports